import { withProcedureWraper } from "../../../../..";
import { Error, Loading } from "../../../../../../../components";
import ProcedureLayout from "../../../../../../../components/layouts/procedure-layout";
import { CreateApplicationForTerminationContractForm } from "../../../../absence-letter/components/create-application-for-termination-contract-form";
import { useAFLRequest } from "../../../../absence-letter/hooks";

export const TerminationContractEditTSN = withProcedureWraper(() => {
  const { data = {}, isLoading: isRequestLoading, isFetching: isRequestFetching, isError } = useAFLRequest();

  if (isRequestLoading) return <Loading />;
  if (isError) return <Error description="Không tìm thấy dữ liệu" />;

  return (
    <ProcedureLayout title="Chỉnh sửa đơn xin chấm dứt hợp đồng lao động" loading={isRequestFetching}>
      <CreateApplicationForTerminationContractForm data={data} />
    </ProcedureLayout>
  );
});
